import PackagePanelContent from './PackagePanelContent'
import {useSelector} from "react-redux";

const PackagePanelContainer = (props) => {
    let {popupType, changeStep, isAnnually, changePlan, active} = props
    let {planData, planType} = useSelector(state => {
        return {
            planData: state.mainReducer.planData,
            planType: state.mainReducer.planType,
        }
    })
    return (
        <PackagePanelContent
            popupType={popupType}
            planData={planData}
            changeStep={changeStep}
            isAnnually={isAnnually}
            changePlan={changePlan}
            planType={planType}
            active={active}
        />
    )
}

export default PackagePanelContainer